module.exports = __webpack_public_path__ + "static/media/app-logo-text.78de34ff.svg";